import { CollectionReport } from "@/components/sales-contracts/collection-report";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_dashboard/collection-report")({
	component: CollectionReportPage,
});

function CollectionReportPage() {
	return (
		<div className="container mx-auto px-4 py-6">
			<div className="mb-6">
				<h1 className="text-3xl font-bold text-gray-900">Collection Report</h1>
				<p className="text-gray-600 mt-2">Monthly collection status tracking for all active contracts</p>
			</div>
			<CollectionReport />
		</div>
	);
}
